import { createSelector } from '@ngrx/store';
import { getIngredientByPLU } from '@shared/state';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';

export const getPriceForIngredient = (PLU: number) =>
    createSelector(getWizzardSimpleItem, getIngredientByPLU(PLU), (simpleItem: OLO.State.Wizzard.WizzardSimpleItem, ingredientModel) => {
        if (!simpleItem) return null;

        const addedIngredient = simpleItem.IngredientsChanges?.IngredientsAdded?.find((ing) => ing.IngredientPLU === PLU);
        const modifiedIngredient = simpleItem.IngredientsChanges?.IngredientsModified?.find((ing) => ing.IngredientPLU === PLU);
        const swapIngredient = simpleItem.IngredientsChanges?.IngredientsSwapped?.find((ing) => ing.NewIngredientPLU === PLU);

        return addedIngredient?.ExtraPrice || modifiedIngredient?.ExtraPrice || swapIngredient?.ExtraPrice || ingredientModel?.ExtraPrice || null;
    });
